import { Dictionary, IntentId, NlpModelId } from '@feedyou/schema'
import { TreeEntryPoint } from './getUsedDialogsPerTreeEntryPoint'

export const getDescriptionForEntryPoint = (entryPoint: TreeEntryPoint) => {
  if (entryPoint === 'main') {
    return 'set as a main dialog'
  }

  if (entryPoint === 'intro') {
    return 'set as an intro dialog'
  }

  if (entryPoint === 'getStarted') {
    return 'set as a Facebook Get started dialog'
  }

  if (entryPoint === 'nlp-triggers') {
    return 'set as an NLP trigger in the Bot settings'
  }

  if (entryPoint === 'nlp-noMatchDialog') {
    return 'set as an NLP No match dialog in the NLP settings'
  }

  if (entryPoint === 'nlp-otherDialog') {
    return 'set as an NLP Other dialog  in the NLP setting'
  }

  if (entryPoint === 'nlp-vulgarismDialog') {
    return 'set as an NLP Vulgarism dialog'
  }

  const defaultDialogMatch = matchForDefaultDialog(entryPoint)
  if (defaultDialogMatch.matched) {
    const { modelId } = defaultDialogMatch

    return `set as a Default dialog in the NLP settings
    (model ${modelId})`
  }

  const toolMatch = matchForToolDialog(entryPoint)
  if (toolMatch.matched) {
    const { index, modelId } = toolMatch

    return `set as a dialog for action tool of NLP provider 
    (model ${modelId}, index ${index})`
  }

  const intentMatch = matchForIntent(entryPoint)
  if (intentMatch.matched) {
    const { modelId, intentId } = intentMatch

    return `set as a trigger dialog in NLP Intent 
    (model ${modelId}, intent ${intentId})`
  }

  const channelGetStartedMatch = matchForChannelGetStarted(entryPoint)
  if (channelGetStartedMatch.matched) {
    const { channelId } = channelGetStartedMatch

    return `set as a Get started dialog in Facebook messenger channel 
    (channel ${channelId})`
  }

  return 'UNABLE_TO_DESCRIBE_ENTRY_POINT'
}

const matchForDefaultDialog = (entryPoint: TreeEntryPoint) => {
  const regex = /nlp-models-(.+?)-defaultDialog/
  const match = entryPoint.match(regex)

  return {
    matched: !!match,
    modelId: match?.[1]
  } as MatcherResult<{ modelId: NlpModelId }>
}

const matchForIntent = (entryPoint: TreeEntryPoint) => {
  const regex = /nlp-models-(.+?)-intents-(.+)/
  const match = entryPoint.match(regex)

  return {
    matched: !!match,
    modelId: match?.[1],
    intentId: match?.[2]
  } as MatcherResult<{ modelId: NlpModelId; intentId: IntentId }>
}

const matchForToolDialog = (entryPoint: TreeEntryPoint) => {
  const regex = /nlp-models-(.+?)-provider-tools-(.+?)-action-dialog/
  const match = entryPoint.match(regex)

  return {
    matched: !!match,
    modelId: match?.[1],
    index: match?.[2]
  } as MatcherResult<{ modelId: NlpModelId; index: string }>
}

const matchForChannelGetStarted = (entryPoint: TreeEntryPoint) => {
  const regex = /channels-(.+?)-getStarted/
  const match = entryPoint.match(regex)

  return {
    matched: !!match,
    channelId: match?.[1]
  } as MatcherResult<{ channelId: string }>
}

type MatcherResult<Groups extends Dictionary<any, string>> =
  | ({ matched: false } & Record<keyof Groups, undefined>) // I <3 PRETTIER
  | ({ matched: true } & Groups)
